import { Button } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router-dom"
import { parsedUser } from "@/common/GetCurrentUser"
import { isSuperAdmin } from "@/common/helpers"
import { Routes } from "@/routes"

const SuperAdminBackLink = () => {
  const { t } = useTranslation("global")
  const history = useHistory()
  const location = useLocation()
  const user = parsedUser()

  if (!isSuperAdmin(user) || location.pathname === Routes.Platform.path) {
    return null
  }

  return (
    <div className="mb-3">
      <Button
        variant="outline-warning"
        size="sm"
        className="d-inline-flex align-items-center gap-2"
        onClick={() => history.push(Routes.Platform.path)}
      >
        <i className="fas fa-arrow-left" />
        {t("Back to Platform Admin")}
      </Button>
    </div>
  )
}

export default SuperAdminBackLink
